// Updated version, depreciate getCardContent
export const getCardContents = card => {
	const cardObj = card?.linkedResource || card;
	let cardContents = {};
	let finalCardContents = {};

	// Check linked resources and fill out cardContents
	const cardType = cardObj.type || cardObj.__typename;

	if (cardType === 'ContentfulPageTemplateWebinar') {
		cardContents = {
			title: cardObj.header,
			description: cardObj.description,
			cardImage: cardObj.featuredImage,
			link: `/webinar/${cardObj.slug}`,
			linkText: 'Watch Webinar',
		};
	}

	if (cardType === 'ContentfulPageTemplateCustomerStory') {
		cardContents = {
			title: cardObj.header,
			description: cardObj.subheader,
			cardImage: cardObj.whiteLogo,
			link: `/customer-stories/${cardObj.slug}`,
			linkText: 'Read Case Study',
		};
	}

	if (cardType === 'ContentfulPageTemplateImpactAudioEpisode') {
		cardContents = {
			title: cardObj.header,
			description: cardObj.episodeCardDescription,
			link: `/impact-audio/${cardObj.slug}`,
			linkText: 'Listen Now',
		};
	}

	if (cardType === 'ContentfulClPs') {
		cardContents = {
			title: cardObj.heroHeader,
			description: cardObj.formOrHeroDescription,
			cardImage: cardObj.videoReplacementImage.file.url,
			link: cardObj.prependSlug
				? `${cardObj.prependSlug}${cardObj.slug}`
				: `/${cardObj.slug}`,
			linkText: 'Download the Guide',
		};
	}

	let defaultCardText;

	switch (card.resourcesCardType?.[0]) {
		case 'Webinar':
			defaultCardText = 'Watch Webinar';
			break;
		case 'Guide':
			defaultCardText = 'Download Guide';
			break;
		case 'Blog':
			defaultCardText = 'Read Blog';
			break;
		default:
			defaultCardText = 'Learn More';
	}

	// check for card overrides
	finalCardContents = {
		type: cardType,
		subType: card.resourcesCardType && card.resourcesCardType[0],
		contentful_id: card.contentful_id,
		title: card.header || cardContents.title,
		description: card.bodyText || cardContents.description,
		cardImage: card.logo?.file.url || cardContents.cardImage,
		link: card.link || cardContents.link,
		linkText: card.linkText || cardContents.linkText || defaultCardText,
	};

	return finalCardContents;
};
